module.exports = __webpack_public_path__ + "static/media/radar.5e3f347e.svg";